import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { GetUserReferencedList } from '../../ApiServices/UserWallet/UserWalletApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import ReferAndEarn from './ReferAndEarn';

const ReferAndEarnHistory = () => {
    const [transactionData, setTransactionData] = useState([])
    const { setLoader } = useContext(LoaderContext);
    const userID = localStorage.getItem("userID")
    useEffect(() => {
        GetUserReferencedListData()
    }, [])

    const GetUserReferencedListData = async () => {
        setLoader(true);
        try {
            let response = await GetUserReferencedList(userID); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);
                const list = response?.DATA || [];
                setTransactionData(list)


            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };
    return (
        <>
            <ReferAndEarn />
            <div className="wallet-history-section">
                {/* Transaction History Table */}
                <div className="wallet-table-wrapper">
                    {transactionData?.length > 0 ? (
                        <div className='card p-3'>
                            <div className="table-responsive">
                                <table className="wallet-table">
                                    <thead>
                                        <tr >
                                            <th>Referrer Name</th>
                                            <th>Referral Name</th>
                                            <th>Wallet Amount (₹)</th>
                                            <th>Registered Date</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {transactionData?.map((value, index) => (
                                            <tr key={index}>
                                                <td>{value.ReferredByName || 'N/A'}</td>
                                                <td>{value.ReferredToName || 'N/A'}</td>
                                                <td>{value.WalletAmount?.toFixed(2) || '0.00'}</td>

                                                <td>{value.RegDate || 'N/A'}</td>
                                                <td>{value.Note || '-'}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>

                        </div>

                    ) : ''}

                </div>

            </div >
        </>
    )
}

export default ReferAndEarnHistory
